// extracted by mini-css-extract-plugin
export default {"container":"Iv-z","brandName":"Jv-z","productName":"Kv-z","productNamePdpEnhancements":"Lv-z","breakLongProductName":"Mv-z"};